<script>
import { app, Location, ShoppingCart } from './../../functions.js';

import ProductAPI from './../../api/product.js';
import BrandsAPI from './../../api/brands.js';
import CategoriesAPI from './../../api/categories.js';

import HeaderFive from './../shared/HeaderFive.vue';
import Footer from './../shared/Footer.vue';
import ProductCard from './../shared/ProductCard.vue';
import ProductCardTwo from './../shared/ProductCardTwo.vue';
import AddToCartDialogue from './../shared/AddToCartDialogue.vue'
import QuickviewDialogue from './../shared/QuickviewDialogue.vue'

import _isEmpty from 'lodash';
export default {
  name: 'Shop',
  components: {
    Footer,
    HeaderFive,
    ProductCard,
    ProductCardTwo,
    AddToCartDialogue,
    QuickviewDialogue
  },
  data () {
    return {
      Location,
      loading: false,
      itemPerPage: 12,
      currentPage: 1,
      maxPage: 1,
      pageList: [],
      products: [],
      no_of_products: 0,
      activeProduct: null,
      price_filter: 'none',
      rating_filter: 0,
      brands: [],
      loading_brands: true,
      main_categories: [],
      loading_brands: true,
      search_input: '',
      sort_by: 'best_seller',
      sort_options: [{
       val: 'best_seller',
       name: 'Bestsellers' 
      },{
       val: 'newest',
       name: 'Newest' 
      },{
       val: 'price_asc',
       name: 'Price (Low to High)' 
      },{
       val: 'price_desc',
       name: 'Price (High to Low)' 
      }]
    }
  },
  mounted () {
    this.loadBrands();
    this.loadMainCategories();
    this.loadProducts();
  },
  watch: {
    $route () {
      this.loadProducts()
    }
  },
  methods: {
    async loadProducts () {
      this.loading = true
      setTimeout(() => {
        try {

          var barangay_code = Location.location.barangay.brgy_code;
          var brand_id = (this.$route.query.brand ? this.$route.query.brand : '')
          var main_category_id = (this.$route.query.category ? this.$route.query.category : '')
          var sub_category_id = (this.$route.query.sub_category ? this.$route.query.sub_category : '')
          var is_deal = (this.$route.query.sale ? this.$route.query.sale : 0)
          var is_gifting = (this.$route.query.gifting ? this.$route.query.gifting : 0)
          var sort_by = (this.$route.query.sort ? this.$route.query.sort : 'best_seller');
          this.sort_by  = sort_by;
          var filter_by = (this.$route.query.pricerange ? this.$route.query.pricerange : 'none')
          var wildcard = (this.$route.query.q ? this.$route.query.q : '')
          var item_per_page = this.itemPerPage
          var ratings = (this.$route.query.ratings ? this.$route.query.ratings : 0)
          this.currentPage = (this.$route.query.page ? this.$route.query.page : 1)
          

          var viewed_collection = sessionStorage.getItem('gsm_vc');
          var collection_data = {
            slug: '',
            name: '',
            products: []
          };

          if(viewed_collection)
          {
            collection_data = JSON.parse(viewed_collection);
          }

          var sku_list = (this.$route.query.collection ? collection_data.products : [] );

          var products_request = ProductAPI.getProducts(barangay_code, brand_id, main_category_id, sub_category_id, is_deal, is_gifting, sort_by, filter_by, wildcard, item_per_page, ratings, sku_list, this.currentPage)
          products_request.then((response) => {
            if (response.status == 'success') {

              this.products = response.products;
              this.no_of_products = response.item_total;
              this.loadPagination();

              if(! _.isEmpty(this.$route.query))
                this.$refs['productlist'].scrollIntoView({ behavior: 'smooth', block: "center" });
            }

            this.loading = false
          })
        } catch (error) {
          this.loading = false
          console.log(error)
        }
      }, 500)
    },
    async loadBrands() {
       try {
        var barangay_code = Location.location.barangay.brgy_code;
        var brands_request = BrandsAPI.getBrands(barangay_code)
        brands_request.then((response) => {
        
          this.brands = response.brands;
       
        })
      } catch (error) {
        console.log(error);
      }
    },
    async loadMainCategories() {
       try {
        var barangay_code = Location.location.barangay.brgy_code;
 
        var main_category_request = CategoriesAPI.getMainCategories(barangay_code)
        main_category_request.then((response) => {
     
          this.main_categories = response.main_categories;
        
        })
      } catch (error) {
        console.log(error);
      }
    },
    loadPagination (item_count) {
      var pagination = []
    
      this.maxPage = Math.ceil(this.no_of_products / this.itemPerPage);
      for (var i = 1; i <= this.maxPage; i++) {
        pagination.push(i)
      }

      this.pageList = pagination
    },
    prevPage () {
      if (this.currentPage > 1) 
        {
           this.currentPage = this.currentPage - 1 

           this.$router.push({ query: { ...this.$route.query, 'page': this.currentPage } })
         }
    },
    nextPage () {
      if (this.currentPage < (this.products.length / this.itemPerPage)) {
       this.currentPage = this.currentPage + 1 
       this.$router.push({ query: { ...this.$route.query, 'page': this.currentPage } })
      }
    },
    goToPage (page) {
      if (page >= 1 && page <= this.maxPage) {
        this.currentPage = page;

       this.$router.push({ query: { ...this.$route.query, 'page': this.currentPage } })
      }
    },
    sort (event) {

        const queryParams =  { ...this.$route.query, 'sort': event.target.value };
        this.$router.push({ query: queryParams });
     
    },
    selectCategory (main_category_id) {

        const queryParams = { ...this.$route.query, 'category': main_category_id };
        if(main_category_id == 'all')
        {
            if(queryParams.brand)
            {
                delete queryParams.brand;
            }

            if(queryParams.category)
            {
              delete queryParams.category;
            }

            if(queryParams.page)
            {
                delete queryParams.page;
            }

            this.$router.push({ query: queryParams });
        }
        else
        {
            if(queryParams.brand)
            {
                delete queryParams.brand;
            }

            if(queryParams.page)
            {
                delete queryParams.page;
            }

            this.$router.push({ query: queryParams });
        }
       

    },
    selectBrand (brand_id) {
  
         const queryParams = { ...this.$route.query, 'brand': brand_id };
        if(brand_id == 'all')
        {
            if(queryParams.brand)
            {
                delete queryParams.brand;
            }
            
            if(queryParams.category)
            {
              delete queryParams.category;
            }

            if(queryParams.page)
            {
                delete queryParams.page;
            }

            this.$router.push({ query: queryParams });
        }
        else
        {
            if(queryParams.category)
            {
                delete queryParams.category;
            }

            if(queryParams.page)
            {
                delete queryParams.page;
            }

            this.$router.push({ query: queryParams });
        }


    },
    priceFilter (price_filter) {

      const queryParams =  { ...this.$route.query, 'pricerange': price_filter };
      
      if(queryParams.page)
      {
          delete queryParams.page;
      }

      this.$router.push({ query: queryParams });

    },
    ratingFilter (rating_filter) {

      const queryParams =  { ...this.$route.query, 'ratings': rating_filter };
      
      if(queryParams.page)
      {
          delete queryParams.page;
      }

      this.$router.push({ query: queryParams });


    },
    search(event)
    {
      event.preventDefault();

      const queryParams =  { ...this.$route.query, 'q': this.search_input };
      
      if(queryParams.page)
      {
          delete queryParams.page;
      }

      this.$router.push({ query: queryParams });
    },
  }
}
</script>

<template>
  <div class="page shop-page">
    <HeaderFive />

    <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-3 ltn__breadcrumb-color-white bg-image plr--9---" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                            
                            <h1 class="section-title white-color">Shop</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Shop</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- PRODUCT DETAILS AREA START -->
    <div class="ltn__product-area ltn__product-gutter mb-120">
        <div class="container" >
            <div class="row">
                <div class="col-lg-8">
                    <div class="ltn__shop-options">
                        <ul>
                            <li>
                                <div class="ltn__grid-list-tab-menu ">
                                    <div class="nav">
                                        <a class="active show" data-toggle="tab" href="#liton_product_grid"><i class="fas fa-th-large"></i></a>
                                        <a data-toggle="tab" href="#liton_product_list"><i class="fas fa-list"></i></a>
                                    </div>
                                </div>
                            </li>
                            <li>
                               <div class="showing-product-number text-right">
                                    <span>Showing {{ (products.length ? ((currentPage-1) * itemPerPage) + 1 : 0) }}–{{ (itemPerPage*currentPage < no_of_products ? itemPerPage*currentPage : no_of_products) }} of {{ no_of_products }} results</span>
                                </div>
                            </li>
                            <li>
                               <div class="short-by text-center">
                                    <select @change="sort($event)" v-model="sort_by" class="nice-select">
           

                                        <option v-for="sopt in sort_options" :value="sopt.val">{{sopt.name}}</option>
                                    </select>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="tab-content" ref="productlist">
                        <div class="tab-pane fade active show" id="liton_product_grid">
                            <div class="ltn__product-tab-content-inner ltn__product-grid-view">
                                <div class="row" v-if="products.length && !loading">
                                    <!-- ltn__product-item -->
                                    <div class="col-xl-4 col-sm-6 col-6" v-for="product of products">

                                        <ProductCard
                                            :product="product"
                                            :id="product.id"
                                            :name="product.title"
                                            :badge="product.discountPercentage"
                                            :rating="product.rating"
                                            :price="product.price"
                                            :sale-price="product.price"
                                            @onQuickview="quickview(product)"
                                            @onAddToCart="showModal()"
                                            @onAddToWishlist="showModal()" />
                                    </div>
                                </div>
                                <div class="row" v-if="!products.length && !loading">
                                  <h5>No Product Found</h5>
                                </div>
                                <div class="row" v-if="loading">
                                  <div class="spinner">
                                      <div class="dot1"></div>
                                      <div class="dot2"></div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="liton_product_list">
                            <div class="ltn__product-tab-content-inner ltn__product-list-view">
                                <div class="row" v-if="products.length && !loading">
                                    <!-- ltn__product-item -->
                                    <div class="col-lg-12" v-for="product of products">

                                         <ProductCardTwo
                                           :product="product"
                                            @onQuickview="quickview(product)"
                                            @onAddToCart="showModal()"
                                            @onAddToWishlist="showModal()"/>
                                    </div>

                                </div>
                                <div class="row" v-if="!products.length && !loading">
                                  <h5>No Product Found</h5>
                                </div>
                                <div class="row" v-if="loading">
                                  <div class="spinner">
                                      <div class="dot1"></div>
                                      <div class="dot2"></div>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ltn__pagination-area text-center" v-if="products.length">
                        <div class="ltn__pagination">
                            <ul>
                                <li><a @click="prevPage"><i class="fas fa-angle-double-left"></i></a></li>
                                <li v-for="page of pageList.length" :class="{'active' : currentPage == page }"><a @click="goToPage(page)">{{ page }}</a></li>
                                <li><a @click="nextPage"><i class="fas fa-angle-double-right"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <aside class="sidebar ltn__shop-sidebar ltn__right-sidebar">
                        <!-- Category Widget -->
                        <div class="widget ltn__menu-widget" v-if="main_categories.length && products.length">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Product categories</h4>
                            <ul>
                                 <li><a @click="selectCategory('all')">Show All <span><i class="fas fa-long-arrow-alt-right"></i></span></a></li>
                                <li><a @click="selectCategory(category.main_category_id)" v-for="category in main_categories" >{{ category.main_category_name }} <span><i class="fas fa-long-arrow-alt-right"></i></span></a></li>
                            </ul>
                        </div>
                        <!-- Category Widget -->
                        <div class="widget ltn__menu-widget"  v-if="brands.length && products.length">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Brands</h4>
                            <ul>
                              <li><a @click="selectBrand('all')">Show All <span><i class="fas fa-long-arrow-alt-right"></i></span></a></li>
                                <li><a @click="selectBrand(brand.brand_id)" v-for="brand in brands">{{ brand.brand_name }} <span><i class="fas fa-long-arrow-alt-right"></i></span></a></li>
                            </ul>
                        </div>
                        <!-- Price Filter Widget -->
                        <div class="widget ltn__price-filter-widget">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Filter by price</h4>
                            <div class="price_filter">
                      
                                <input type="radio" id="price-filter-none" value="none" v-model="price_filter" @click="priceFilter('none')">
                                <label for="price-filter-none">Show All</label><br>

                                <input type="radio" id="price-filter-1"  value="pricerange_1" v-model="price_filter" @click="priceFilter('pricerange_1')">
                                <label for="price-filter-1">Below ₱ 149.00</label><br>

                                <input type="radio" id="price-filter-2"  value="pricerange_2" v-model="price_filter" @click="priceFilter('pricerange_2')">
                                <label for="price-filter-2">{{ 150 | currencyFormat }} - {{ 399 | currencyFormat }}</label><br>
                      

                                <input type="radio" id="price-filter-3" value="pricerange_3" v-model="price_filter" @click="priceFilter('pricerange_3')">
                                <label for="price-filter-3">{{ 400 | currencyFormat }} - {{ 699 | currencyFormat }}</label><br>
                      

                                <input type="radio" id="price-filter-4"  value="pricerange_4" v-model="price_filter" @click="priceFilter('pricerange_4')">
                                <label for="price-filter-4">{{ 700 | currencyFormat }} - {{ 799 | currencyFormat }} </label><br>
                      

                                <input type="radio" id="price-filter-5" value="pricerange_5" v-model="price_filter" @click="priceFilter('pricerange_5')">
                                <label for="price-filter-5">{{ 800 | currencyFormat }} Above</label><br>
                            </div>
                        </div>

                        <!-- Ratings Filter Widget -->
                       <!--  <div class="widget ltn__price-filter-widget">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Ratings</h4>
                            <div class="ratings-filter">
                      
                                <input type="radio" id="ratings-all" value="0" v-model="rating_filter" @click="ratingFilter(0)">
                                <label for="ratings-all">Show All</label><br>

                                <input type="radio" id="ratings-top"  value="3" v-model="rating_filter" @click="ratingFilter(3)">
                                <label for="ratings-top">Top Ratings</label><br>
                            </div>
                        </div> -->

                   
                        <!-- Search Widget -->
                        <div class="widget ltn__search-widget">
                            <h4 class="ltn__widget-title ltn__widget-title-border">Search</h4>
                            <form>
                                <input type="text" name="search" v-model="search_input" placeholder="Search your keyword...">
                                <button type="submit" @click="search"><i class="fas fa-search"></i></button>
                            </form>
                        </div>
               

                    </aside>
                </div>
            </div>

        </div>
    </div>
    <!-- PRODUCT DETAILS AREA END -->
   <AddToCartDialogue ref="addToCartDialogue" />
   <QuickviewDialogue ref="quickviewDialogue" />
    <Footer />

  </div>
</template>
<style scoped>
.ltn__menu-widget > ul li a {
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s all ease;
}
.ltn__menu-widget > ul li a:hover {
 color: var(--ltn__secondary-color);
}
</style>


// WEBPACK FOOTER //
// src/components/page/Shop.vue